import { useState, useEffect } from 'react'

export type Theme = 'dark' | 'light'

function getInitial(): Theme {
  try {
    const s = localStorage.getItem('mi-theme')
    if (s === 'dark' || s === 'light') return s
  } catch {}
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark'
}

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(getInitial)

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
    try { localStorage.setItem('mi-theme', theme) } catch {}
  }, [theme])

  const toggle = () => setTheme(t => t === 'dark' ? 'light' : 'dark')
  return { theme, toggle }
}
